import { createSelector } from '@ngrx/store';
import { UsersSelectors } from './users.selectors';

export class UsersViewSelectors {
  public static readonly viewHQHoursApprovalPage = UsersSelectors.isSchedulingTeam;
  public static readonly viewLocationHoursApprovalPage = UsersSelectors.isLocationManager;

  public static readonly viewHQPayoutPage = UsersSelectors.isAdmin;
  public static readonly viewLocationPayoutPage = UsersSelectors.isLocationManager;

  public static readonly viewSearchPage = UsersSelectors.isLocationManager;
  public static readonly viewLocationAgendaPage = UsersSelectors.isLocationManager;
  public static readonly viewCandidatesPage = UsersSelectors.isLocationManager;

  public static readonly viewApproachesPage = UsersSelectors.isSchedulingTeam;

  public static readonly viewLinksToPerza = UsersSelectors.isSchedulingTeam;

  public static readonly canViewWeeklySchedules = createSelector(UsersSelectors.roles, (roles) =>
    roles.some((role) =>
      ['ROLE_SKOLEO_TT_PLANNER_WEEKLY_SCHEDULE', 'ROLE_SKOLEO_TT_PLANNER_ADMIN'].includes(role),
    ),
  );

  public static readonly canMailWeeklySchedules = createSelector(UsersSelectors.roles, (roles) =>
    roles.some((role) =>
      ['ROLE_SKOLEO_TT_PLANNER_WEEKLY_SCHEDULE_MAIL', 'ROLE_SKOLEO_TT_PLANNER_ADMIN'].includes(
        role,
      ),
    ),
  );
}
